/**
 * The old enrollment page. Each school year has its own enroll page now
 * (years/:yearSlug/enroll), so anything still pointing here goes to the
 * selected year's, inside the office's view of a family when that's where it
 * was opened.
 */
import { Navigate, useOutletContext } from 'react-router-dom';
import type { AppLayoutContext } from '~/types';
import { useViewAsFamily } from '~/hooks/useViewAsFamily';
import { NO_ENROLLMENT, Notice } from '../EnrollChecklist/shared';

export default function ParentEnrollment() {
  const { school, roleContext } = useOutletContext<AppLayoutContext>();
  const { basePath } = useViewAsFamily(school?.slug);
  const yearSlug = roleContext?.selectedSchoolYear?.slug;

  if (!yearSlug) {
    return (
      <div className="p-4 md:p-6">
        <Notice title="Enrollment">{NO_ENROLLMENT}</Notice>
      </div>
    );
  }

  return <Navigate to={`${basePath}/years/${yearSlug}/enroll`} replace />;
}
